"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = require("./datapoints");
var markItemsAsPinnedService_1 = require("../services/markItemsAsPinnedService");
var owa_mail_list_actions_1 = require("owa-mail-list-actions");
var filterConversationRowsByRestriction_1 = require("owa-mail-list-store/lib/utils/filterConversationRowsByRestriction");
var getTableConversationRelation_1 = require("owa-mail-list-store/lib/utils/getTableConversationRelation");
var pinningUtils_1 = require("owa-mail-list-store/lib/utils/pinningUtils");
var actionTypes_1 = require("owa-mail-store/lib/actions/actionTypes");
var undoActions = require("owa-mail-undo");
var legacy_1 = require("satcheljs/lib/legacy");
var stitch_1 = require("satcheljs/lib/legacy/stitch");
var owa_mail_list_store_1 = require("owa-mail-list-store");
function getItemIdsToUpdate(rowKeys, tableViewId, shouldMarkAsPinned) {
    var itemIdsToUpdate = {};
    for (var i = 0; i < rowKeys.length; i++) {
        var tableConversationRelation = getTableConversationRelation_1.default(rowKeys[i], tableViewId);
        if (shouldMarkAsPinned) {
            // If pinning, pin the last item in each conversation. The last delivered item is first in the list of ItemIds
            var itemId = tableConversationRelation.itemIds[0];
            if (!itemIdsToUpdate[itemId]) {
                itemIdsToUpdate[itemId] = true;
            }
        }
        else {
            // If unpinning, unpin all local items in conversation.
            tableConversationRelation.itemIds.forEach(function (itemId) {
                if (!itemIdsToUpdate[itemId]) {
                    itemIdsToUpdate[itemId] = true;
                }
            });
        }
    }
    return Object.keys(itemIdsToUpdate);
}
function shouldPerformPinUnpinAction(tableConversationRelation, pin) {
    return tableConversationRelation && pinningUtils_1.getIsConversationPinned(tableConversationRelation) != pin;
}
exports.default = legacy_1.action('pinConversations', datapoints_1.default.pinConversationsDatapoint)(function pinConversations(conversationRowKeys, tableView, shouldMarkAsPinned, actionSource) {
    undoActions.clearLastUndoableAction();
    var filteredRowKeys = filterConversationRowsByRestriction_1.default(conversationRowKeys, tableView.id, shouldPerformPinUnpinAction, shouldMarkAsPinned);
    var conversationIdStrings = owa_mail_list_store_1.getRowIdsFromRowKeys(filteredRowKeys, tableView.id);
    var itemIdsToUpdate = getItemIdsToUpdate(filteredRowKeys, tableView.id, shouldMarkAsPinned);
    if (itemIdsToUpdate.length == 0) {
        // No need to send out the service call
        return Promise.resolve();
    }
    stitch_1.raiseAction(actionTypes_1.actionNames.MarkConversationsAsPinned)(conversationIdStrings, tableView.id, shouldMarkAsPinned);
    // Treat this pinning operation as a row move operation
    owa_mail_list_actions_1.setRowOperation(tableView, 2 /* RowMove */);
    // Make service request
    // Task 658: Reload client state when pin action fails on the server
    markItemsAsPinnedService_1.default(itemIdsToUpdate, shouldMarkAsPinned);
    // return the promise to catch the end to end time of pinConversationDatapoint
    return Promise.resolve();
});
//# sourceMappingURL=pinConversations.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/pinConversations.js
// module id = 3821
// module chunks = 62